import React from "react";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <section style={styles.hero}>
      <div style={styles.overlay}></div>
      <div style={styles.content}>
        <h1 style={styles.title}>L’ARTISAN</h1>
        <p style={styles.subtitle}>
          Discover the beauty of handcrafted art — 
          <br />
          wooden decor, antiques & elegant handmade creations.
        </p>
        <Link to="/shop" style={styles.btn}>
          Explore Collection →
        </Link>
      </div>
    </section>
  );
};

const styles = {
  hero: {
    position: "relative",
    height: "90vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    backgroundImage:
      "url('https://res.cloudinary.com/defcamc5x/image/upload/v1762092234/v5zkbqdrhhigvw1jtnmc.webp')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    textAlign: "center",
    overflow: "hidden",
  },
  overlay: {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(to bottom right, rgba(91,58,41,0.85), rgba(138,143,58,0.65))",
    zIndex: 1,
  },
  content: {
    position: "relative",
    zIndex: 2,
    maxWidth: "700px",
    padding: "20px",
  },
  title: {
    fontSize: "68px",
    fontWeight: "700",
    letterSpacing: "2px",
    marginBottom: "20px",
    color: "#fff",
    textShadow: "2px 2px 8px rgba(0,0,0,0.4)",
  },
  subtitle: {
    fontSize: "20px",
    lineHeight: "1.6",
    color: "#f5f5f5",
    marginBottom: "30px",
  },
  btn: {
    backgroundColor: "#8a8f3a",
    color: "#fff",
    padding: "14px 30px",
    borderRadius: "8px",
    textDecoration: "none",
    fontWeight: "600",
    fontSize: "18px",
    transition: "0.3s",
  },
};

// Hover effect
const styleSheet = document.createElement("style");
styleSheet.innerHTML = `
a:hover {
  background-color: #a4aa4b !important;
}
@media (max-width: 768px) {
  h1 {
    font-size: 42px !important;
  }
  p {
    font-size: 16px !important;
  }
}
`;
document.head.appendChild(styleSheet);

export default Hero;
